import React, { useEffect, useState, useRef } from 'react';
import { useUserProfile } from '../masterLayout/MasterLayoutBody';
import { useSetting } from '../utils/AppSettingsContext';
import {
  createClass,
  updateClass,
  deleteClass,
  getClass,
  getClassByName
} from '../api/classAPI';
import { getCategory } from '../api/categoryAPI';
import $ from 'jquery';
import { Icon } from '@iconify/react';

const ClassListLayer = () => {
  const userProfile = useUserProfile();
  const [classList, setClassList] = useState([]);
  const [newClass, setNewClass] = useState({});
  const [categoryList, setCategoryList] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [errors, setErrors] = useState({});
  const tableRef = useRef(null);
  const dtRef = useRef(null);
  const showAssetCategory = useSetting('show_asset_category');

  const fetchData = async () => {
    const data = await getClass();
    setClassList(data);
  };

  const validateForm = () => {
    const newErrors = {};
    if (!newClass.className?.trim()) newErrors.className = 'Class name is required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (showAssetCategory) {
      getCategory().then(setCategoryList);
    } else {
      setCategoryList([]);
    }
  }, [showAssetCategory]);

  useEffect(() => {
    if (dtRef.current) dtRef.current.destroy();
    if (classList.length > 0) {
      dtRef.current = $(tableRef.current).DataTable({ pageLength: 25, dom: 'rtip' });
    }
    return () => dtRef.current?.destroy(true);
  }, [classList]);

  useEffect(() => {
    dtRef.current?.search(searchTerm).draw();
  }, [searchTerm]);

  const handleSave = async () => {
    if (!validateForm()) return;
    const dup = await getClassByName(newClass.className, editingId);
    if (dup) {
      setErrors({ className: 'Class name already exists' });
      return;
    }
    const clean = {};
    for (const key in newClass) {
      if (newClass[key] !== null && typeof newClass[key] !== 'object') {
        clean[key] = newClass[key];
      }
    }
    clean.categoryId = newClass.categoryId ?? null;
    editingId ? await updateClass(editingId, clean) : await createClass(clean);
    setShowModal(false);
    setEditingId(null);
    if (dtRef.current) { dtRef.current.destroy(); dtRef.current = null; }
    setNewClass({});
    await fetchData();
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete class?')) return;
    await deleteClass(id);
    if (dtRef.current) { dtRef.current.destroy(); dtRef.current = null; }
    await fetchData();
  };

  return (
    <div className="card h-100 p-0 rounded-0">
      <div className="card-header d-flex justify-content-between p-3">
        <input type="text" className="form-control w-auto" placeholder="Search..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
        {userProfile?.privileges?.includes('class:create') && (
          <button className="btn btn-primary btn-sm d-flex align-items-center gap-2" onClick={() => { setNewClass({}); setEditingId(null); setShowModal(true); }}>
            <Icon icon="ic:baseline-plus" className="icon text-xl" /> Add Class
          </button>
        )}
      </div>
      <div className="card-body p-0">
        <div className="table-responsive scroll-sm">
          <table ref={tableRef} className="table bordered-table mb-0">
            <thead>
              <tr>
                <th>Class Name</th>
                {showAssetCategory && <th>Category</th>}
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {classList.map(item => (
                <tr key={item.id}>
                  <td><strong>{item.className}</strong></td>
                  {showAssetCategory && (
                    <td>{item.category?.categoryName || ''}</td>
                  )}
                  <td>
                    <div className="d-flex gap-2">
                      {userProfile?.privileges?.includes('class:update') && (
                        <button className="w-32-px h-32-px bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                          onClick={() => { setNewClass(item); setEditingId(item.id); setShowModal(true); }}>
                          <Icon icon="ic:baseline-edit" className="icon text-xl line-height-1" />
                        </button>
                      )}
                      {userProfile?.privileges?.includes('class:delete') && (
                        <button className="w-32-px h-32-px bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
                          onClick={() => handleDelete(item.id)}>
                          <Icon icon="ic:baseline-delete-outline" className="icon text-xl line-height-1" />
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {showModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog modal-lg"><div className="modal-content">
            <div className="modal-header"><h5 className="modal-title">{editingId ? 'Edit Class' : 'New Class'}</h5><button className="btn-close" onClick={() => setShowModal(false)} /></div>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">Class Name *</label>
                <input className={`form-control ${errors.className ? 'is-invalid' : ''}`} name="className" value={newClass.className || ''} onChange={(e) => handleInputChange(e)} />
                {errors.className && <div className="invalid-feedback">{errors.className}</div>}
              </div>
              {showAssetCategory && (
                <div className="mb-3">
                  <label className="form-label">Category</label>
                  <select className="form-select" name="categoryId" value={newClass.categoryId || ''} onChange={handleInputChange}>
                    <option value="">Select Category</option>
                    {categoryList.map(c => (
                      <option key={c.id} value={c.id}>{c.categoryName}</option>
                    ))}
                  </select>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Close</button>
              <button className="btn btn-primary" onClick={handleSave}>Save</button>
            </div>
          </div></div>
        </div>
      )}
    </div>
  );

  function handleInputChange(e) {
    const { name, value } = e.target;
    setNewClass(prev => ({
      ...prev,
      [name]: name === 'categoryId' ? (value ? Number(value) : null) : value
    }));
  }
};

export default ClassListLayer;
